module.exports = __webpack_public_path__ + "/images/cover-multi-recibiendo-dinero-002-it.64de98a.png";